<script>
import MottoIcon from '@components/motto-icon.vue'
import _ from 'lodash'
export default {
  components: {
    MottoIcon,
  },
  props: {
    startTutorialFn: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      addMargin: false,
      yVisibleOffset: 100,
    }
  },
  computed: {
    bottomOffset() {
      const defaultYOffset = _.isEmpty(this.$store.getters['survey/currentPageSurvey']) ? 20 : 100

      if (!this.addMargin) {
        return defaultYOffset
      }

      if (this.isMobile) {
        return 170 + defaultYOffset
      }

      return defaultYOffset
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.addMargin = window.scrollY > this.yVisibleOffset
    },
  },
}
</script>

<template
  ><div class="d-contents">
    <div :class="[$style.graduationContainer]" :style="{ bottom: bottomOffset + 'px' }" @click="startTutorialFn">
      <MottoIcon :class="$style.graduationCap" name="GraduationCap" icon-color="white"></MottoIcon>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.graduationCap {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 20000;
  cursor: pointer;
  transform: translateX(-50%) translateY(-50%);

  svg {
    display: inline;
    width: 38px;
    height: 38px;
    animation-name: shake;
    animation-duration: 0.5s;
    animation-timing-function: ease-in-out;
    animation-delay: 0.5s;
    animation-iteration-count: 3;
  }
}

.graduationContainer {
  @media (max-width: $lg-breakpoint) {
    bottom: 100px;
  }

  position: fixed;
  right: 22px;
  bottom: 20px;
  z-index: 999;
  width: 60px;
  height: 60px;
  cursor: pointer;
  background: $secondary-orange;
  border-radius: 50%;
  transition: all 0.3s ease;
}

@keyframes shake {
  0%,
  100% {
    transform: rotate(0deg);
  }
  20%,
  60% {
    transform: rotate(12deg);
  }
  40%,
  80% {
    transform: rotate(-12deg);
  }
}
</style>
